import React from 'react';
import { motion } from 'framer-motion';
export function TermsOfService() {
  const sections = [{
    title: 'Acceptance of Terms',
    content: 'By accessing and using djilicreations.com, you accept and agree to be bound by the terms and provisions of this agreement. If you do not agree to abide by the above, please do not use this service.'
  }, {
    title: 'Use of the Site',
    content: 'All content on this site, including text, graphics, logos, and imagery, is the property of Djily Creations and is protected by international copyright laws. Unauthorized reproduction or distribution is strictly prohibited.'
  }, {
    title: 'Orders & Payments',
    content: 'All orders are subject to acceptance and availability. Prices are listed in US Dollars (USD) and are subject to change without notice. We reserve the right to refuse or cancel any order for any reason at our sole discretion.'
  }, {
    title: 'Bespoke Services',
    content: 'Custom and bespoke pieces are made-to-order and are non-refundable. By placing a bespoke order, you acknowledge the unique nature of the craftsmanship and the lead times required for production.'
  }, {
    title: 'Limitation of Liability',
    content: 'Djily Creations shall not be liable for any direct, indirect, incidental, special, or consequential damages arising from the use of or inability to use our products or services.'
  }, {
    title: 'Governing Law',
    content: 'These terms shall be governed by and construed in accordance with the laws of the Commonwealth of Virginia, United States, without regard to its conflict of law provisions.'
  }];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-827">
      <div className="max-w-3xl mx-auto" data-id="element-828">
        <motion.header initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-20 text-center" data-id="element-829">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-6 block text-black/40" data-id="element-830">
            Legal
          </span>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-831">
            Terms of Service
          </h1>
          <p className="text-xs md:text-sm font-display font-bold tracking-widest text-black/40 uppercase" data-id="element-832">
            Last Updated: January 2024
          </p>
        </motion.header>

        <div className="space-y-16" data-id="element-833">
          {sections.map((section, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border-l-2 border-black pl-8" data-id="element-834">
              <div className="flex items-baseline space-x-4 mb-4" data-id="element-835">
                <span className="text-xs md:text-sm font-display font-bold tracking-widest text-black/30" data-id="element-836">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase" data-id="element-837">
                  {section.title}
                </h2>
              </div>
              <p className="text-sm md:text-base font-normal text-black/70 leading-relaxed tracking-wide" data-id="element-838">
                {section.content}
              </p>
            </motion.div>)}
        </div>

        <div className="mt-24 pt-12 border-t border-grey-divider text-center" data-id="element-839">
          <p className="text-[12px] font-display font-bold tracking-widest uppercase text-black/40 mb-4" data-id="element-840">
            Questions about our Terms?
          </p>
          <a href="tel:5718423307" className="text-base font-display font-bold tracking-widest uppercase hover:opacity-50 transition-opacity" data-id="element-841">
            Contact: (571) 842-3307
          </a>
        </div>
      </div>
    </div>;
}